<template>
    <div class="ppv2-flex ppv2-mt-2 ppv2-w-full" :style="{ paddingLeft: this.normalizeSize(55), gap: this.normalizeSize(60) }">
        <div class="form-section">
            <HeaderStep :step="step" :sizes="sizes" />

            <p v-if="error" class="error-text ppv2-mb-4">
                {{ error }}
            </p>

            <div
                v-if="selectedOptionReservationMode === 'multiple_time_slots'"
                :style="{ marginTop: normalizeSizeVertical(60, true) }"
            >
                <!-- Paramètres avancés -->
                <div class="d-flex justify-content-end align-items-center mb-3">
                    <label
                        class="d-flex align-items-center ppv2-text-black ppv2-text-opacity-80 ppv2-cursor-pointer"
                        :style="{ gap: normalizeSize(12, true) }"
                        @click="showAdvancedParams = !showAdvancedParams"
                    >
                        <Settings :size="14" />
                        <span :style="{ fontSize: normalizeFontSize(12) }">{{ $t('experience.step4.advancedParams') }}</span>
                        <ChevronUp v-if="showAdvancedParams" :size="12" />
                        <ChevronDown v-else :size="12" />
                    </label>
                </div>

                <div v-if="showAdvancedParams" class="d-flex align-items-center mb-2">
                    <div
                        class="ppv2-bg-white ppv2-bg-opacity-5 ppv2-flex ppv2-justify-between border_duration_experience ppv2-text-black d-flex align-items-center px-3"
                        style="width: 100%"
                    >
                        <label
                            class="ppv2-truncate poppinsRegular"
                            :style="{ fontSize: normalizeFontSize(13), width: `calc(100% - ${normalizeSize(145, true)})` }"
                        >
                            {{ $t('experience.step4.add_start_time.Question') }}
                        </label>
                        <div :style="{ width: normalizeSize(130, true) }">
                            <CustomInput
                                v-model="add_start_time"
                                type="number"
                                rightIcon="minutes"
                                :fontSizeIconRight="10"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-lg"
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :floatingLabel="true"
                            />
                        </div>
                    </div>
                </div>

                <div v-if="showAdvancedParams" class="d-flex align-items-center mb-2">
                    <div
                        class="ppv2-bg-white ppv2-bg-opacity-5 ppv2-flex ppv2-justify-between border_duration_experience ppv2-text-black d-flex align-items-center px-3"
                        style="width: 100%"
                    >
                        <label
                            class="ppv2-truncate poppinsRegular"
                            :style="{ fontSize: normalizeFontSize(13), width: `calc(100% - ${normalizeSize(145, true)})` }"
                        >
                            {{ $t('experience.step4.cleaning_time.Question') }}
                        </label>
                        <div :style="{ width: normalizeSize(130, true) }">
                            <CustomInput
                                v-model="cleaning_time"
                                type="number"
                                rightIcon="minutes"
                                :fontSizeIconRight="10"
                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-[4px]"
                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                :floatingLabel="true"
                            />
                        </div>
                    </div>
                </div>

                <ReservationPeriods
                    v-if="showAdvancedParams && localPrestation && localPrestation.id"
                    :prestationId="localPrestation.id"
                />

                <!-- Intervalle -->
                <div
                    class="gestion_creneau ppv2-flex ppv2-flex-wrap ppv2-items-center ppv2-justify-between ppv2-border ppv2-border-[#545595] ppv2-rounded-[12px] ppv2-text-black ppv2-mb-2 ppv2-px-3 ppv2-min-h-[54px]"
                >
                    <label
                        class="ppv2-truncate poppinsRegular"
                        :style="{ width: `calc(100% - ${normalizeSize(175, true)})`, fontSize: normalizeFontSize(13) }"
                    >
                        {{ $t('experience.step4.interval.Question') }}
                    </label>

                    <div :style="{ width: normalizeSize(160, true) }">
                        <BaseSelect
                            v-model="selected_interval_reservation"
                            customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                            :customSizeLabel="11"
                            compact
                            :options="options_interval_reservation"
                            :searchable="false"
                            option-label="label"
                            option-value="value"
                            class="transparent-select ppv2-w-full"
                            class-added="!ppv2-rounded-[4px] !ppv2-h-[30px]"
                            @open="activeField = 'duration'"
                            :placeholder="$t('common.select')"
                        />
                    </div>
                </div>

                <!-- Durée -->
                <div :class="['d-flex align-items-center', errors.duration ? 'mb-0' : 'mb-2']">
                    <div
                        class="ppv2-bg-white ppv2-bg-opacity-5 ppv2-flex ppv2-justify-between border_duration_experience ppv2-text-black d-flex align-items-center px-3"
                        style="width: 100%"
                    >
                        <label
                            class="ppv2-truncate poppinsRegular"
                            :style="{ fontSize: normalizeFontSize(13), width: `calc(100% - ${normalizeSize(175, true)})` }"
                        >
                            {{ $t('experience.step4.duration.Question') }}
                        </label>
                        <div :style="{ width: normalizeSize(160, true) }">
                            <BaseSelect
                                v-model="selected_duration_experience"
                                customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                :customSizeLabel="11"
                                compact
                                :options="getFilteredDurations(selected_duration_experience)"
                                :searchable="false"
                                :disabled="!selected_interval_reservation"
                                option-label="label"
                                option-value="value"
                                class="transparent-select ppv2-w-full"
                                class-added="!ppv2-rounded-[4px] !ppv2-h-[30px]"
                                @open="activeField = 'duration'"
                                :placeholder="$t('common.select')"
                            />
                            <span
                                v-if="!options_durations_experience.some((o) => o.value === selected_duration_experience)"
                                class="ppv2-text-sm"
                            >
                            </span>
                        </div>
                    </div>
                </div>
                <p v-if="errors.duration" class="ppv2-text-[#ed4b9e] ppv2-text-xs ppv2-mt-2 ppv2-mb-2">
                    {{ errors.duration }}
                </p>

                <!-- Gestion des options de durée -->
                <div class="duration-options-section ppv2-mb-3">
                    <div class="duration-options-header">
                        <h4 class="duration-options-title">
                            {{ $t('experience.step4.optionDuration.title') }}
                        </h4>
                        <span class="duration-options-badge">{{ durationOptionBlocks.length }}</span>
                    </div>

                    <div class="duration-options-body">
                        <p v-if="durationOptionBlocks.length === 0" class="duration-options-empty">
                            {{ $t('experience.step4.optionDuration.emptyHint') }}
                        </p>
                        <div
                            v-for="(block, optionIndex) in durationOptionBlocks"
                            :key="`block-${block.originalIndex}`"
                            class="duration-option-item"
                        >
                            <div class="duration-option-row">
                                <div class="duration-option-row-head">
                                    <div v-if="editingOptionIndex === block.originalIndex" class="ppv2-w-full ppv2-pr-3">
                                        <CustomInput
                                            :value="optionNameDraft"
                                            :label="$t('experience.step4.optionDuration.optionNameLabel')"
                                            customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                            :customSizeLabel="11"
                                            classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-lg"
                                            classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                            @input="optionNameDraft = $event"
                                            @blur="saveOptionName(block.originalIndex, optionIndex)"
                                            @enter="saveOptionName(block.originalIndex, optionIndex)"
                                            :floatingLabel="true"
                                            :floatingLabelBg="theme.mode === 'dark' ? '#121733' : '#fff'"
                                        />
                                    </div>
                                    <div v-else class="duration-option-name-wrap">
                                        <span class="duration-option-name">{{ getOptionName(block, optionIndex) }}</span>
                                        <button
                                            type="button"
                                            class="duration-option-edit ppv2-text-black"
                                            @click="startEditingOptionName(block.originalIndex, optionIndex)"
                                        >
                                            <Pencil :size="13" />
                                        </button>
                                    </div>
                                </div>

                                <div class="duration-option-controls">
                                    <div
                                        class="duration-option-select-wrap"
                                        :style="{
                                            width:
                                                Number(block.value) === -1 ? normalizeSize(305, true) : normalizeSize(160, true),
                                        }"
                                    >
                                        <div :style="{ width: normalizeSize(160, true) }">
                                            <BaseSelect
                                                :value="block.value"
                                                :label="$t('experience.step4.optionDuration.durationLabel')"
                                                customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                                :customSizeLabel="11"
                                                compact
                                                :options="getFilteredDurations(block.value)"
                                                :searchable="false"
                                                option-label="label"
                                                option-value="value"
                                                class="transparent-select ppv2-w-full"
                                                class-added="!ppv2-rounded-lg !ppv2-h-[30px]"
                                                @input="onAdditionalBlockValueChange(block.originalIndex, $event)"
                                                :floatingLabel="true"
                                                :placeholder="$t('common.select')"
                                            />
                                        </div>
                                        <div v-if="Number(block.value) === -1" :style="{ width: normalizeSize(130, true) }">
                                            <CustomInput
                                                :value="block.personilize"
                                                :label="$t('experience.step4.optionDuration.customLabel')"
                                                customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                                :customSizeLabel="11"
                                                type="number"
                                                :rightIcon="
                                                    errors[getCustomErrorKey(block, block.originalIndex)]
                                                        ? ''
                                                        : `(${$t('common.min')})`
                                                "
                                                :fontSizeIconRight="10"
                                                classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-lg"
                                                classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                                @input="onAdditionalBlockCustomInput(block.originalIndex, $event)"
                                                :state="getState(getCustomErrorKey(block, block.originalIndex))"
                                                :errorText="errors[getCustomErrorKey(block, block.originalIndex)]"
                                                :floatingLabel="true"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="block.originalIndex !== 0" class="duration-option-remove-wrap">
                                        <button
                                            type="button"
                                            class="duration-option-remove-btn"
                                            @click="removeDurationBlock(block.originalIndex)"
                                        >
                                            <X :size="15" />
                                        </button>
                                    </div>
                                    <div v-else class="duration-option-remove-spacer"></div>
                                </div>
                            </div>

                            <!-- Durées par nombre de personnes ("paliers").
                                 Même donnée que l'étape Tarification : les paliers saisis ici y
                                 réapparaissent avec leur prix, et réciproquement. -->
                            <button
                                v-if="hasDynamicDuration"
                                type="button"
                                class="tier-toggle-link"
                                @click="toggleTiers(block.originalIndex)"
                            >
                                {{
                                    isTiersOpen(block.originalIndex)
                                        ? $t('experience.tiers.hideLink')
                                        : $t('experience.tiers.configureLink')
                                }}
                            </button>

                            <div v-if="hasDynamicDuration && isTiersOpen(block.originalIndex)" class="tier-panel">
                                <p class="tier-hint">{{ $t('experience.tiers.fallbackHint') }}</p>

                                <div
                                    v-for="(tier, tierIndex) in block.prices_degressif || []"
                                    :key="`tier-${block.originalIndex}-${tierIndex}`"
                                    class="tier-row"
                                >
                                    <span class="tier-label">{{ $t('experience.tiers.palier') }} {{ tierIndex + 1 }}</span>

                                    <div class="tier-field">
                                        <CustomInput
                                            :value="tier.persons"
                                            :label="$t('experience.tiers.persons')"
                                            type="number"
                                            :required="true"
                                            :state="getTierState(block.originalIndex, tierIndex)"
                                            :errorText="getTierError(block.originalIndex, tierIndex)"
                                            @input="updateTier(block.originalIndex, tierIndex, 'persons', $event)"
                                            classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-lg"
                                            classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                            :customSizeLabel="11"
                                            :floatingLabel="true"
                                            :floatingLabelBg="theme.mode === 'dark' ? '#121733' : '#fff'"
                                        />
                                    </div>

                                    <!-- Liste déroulante, comme la durée de l'option juste au-dessus :
                                         la même grille (getTierDurationOptions), sans aucune durée
                                         exclue. -->
                                    <div class="tier-field">
                                        <BaseSelect
                                            :value="tier.duration"
                                            :label="$t('experience.tiers.duration')"
                                            customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                            :customSizeLabel="11"
                                            compact
                                            :options="getTierDurationOptions()"
                                            :searchable="false"
                                            option-label="label"
                                            option-value="value"
                                            class="transparent-select ppv2-w-full"
                                            class-added="!ppv2-rounded-lg !ppv2-h-[30px]"
                                            @input="updateTier(block.originalIndex, tierIndex, 'duration', $event)"
                                            :floatingLabel="true"
                                            :placeholder="$t('common.select')"
                                        />
                                        <p
                                            v-if="getTierError(block.originalIndex, tierIndex, 'duration')"
                                            class="tier-field-error"
                                        >
                                            {{ getTierError(block.originalIndex, tierIndex, 'duration') }}
                                        </p>
                                    </div>

                                    <!-- « Personnalisée » (-1) : la vraie durée vit dans `personilize`,
                                         même convention que la durée de l'option. C'est ce qui permet
                                         de saisir 20, 28 ou 36 min, hors grille de l'intervalle. -->
                                    <div v-if="Number(tier.duration) === -1" class="tier-field">
                                        <CustomInput
                                            :value="tier.personilize"
                                            :label="$t('experience.step4.custom_duration.title')"
                                            customLabelClass="poppinsRegular ppv2-text-black ppv2-text-opacity-80"
                                            :customSizeLabel="11"
                                            type="number"
                                            :rightIcon="`(${$t('common.min')})`"
                                            :fontSizeIconRight="10"
                                            classInputAdd="!ppv2-min-h-[30px] !ppv2-h-[30px] !ppv2-rounded-lg"
                                            classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0"
                                            :floatingLabel="true"
                                            @input="updateTier(block.originalIndex, tierIndex, 'personilize', $event)"
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        class="duration-option-remove-btn"
                                        @click="removeTier(block.originalIndex, tierIndex)"
                                    >
                                        <X :size="15" />
                                    </button>
                                </div>

                                <button type="button" class="duration-option-add-btn" @click="addTier(block.originalIndex)">
                                    <Plus :size="14" />
                                    {{ $t('experience.tiers.add') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="duration-option-add-wrapper ppv2-mb-3">
                    <button id="add-duration-option" type="button" class="duration-option-add-btn" @click="addDurationBlock">
                        <Plus :size="14" />
                        {{ $t('experience.step4.optionDuration.addButton') }}
                    </button>
                </div>

                <!-- 🟣 Cas 1 : isOn = false -->
                <SelectableList
                    :label="$t('experience.step4.specifityHoraire.Question')"
                    v-model="selectedOptionSpecifityHoraire"
                    :options="options_specifity_horaire"
                    :customStyle="{ marginTop: normalizeSizeVertical(55) }"
                />
                <!-- 🟢 Cas 2 : isOn = true -->
                <DashedCard
                    :title="$t('experience.step4.multiMode.schedule.configSchedule')"
                    v-if="selectedOptionSpecifityHoraire == 1"
                    :marginTop="70"
                    :marginBottom="70"
                    :custom-style="{ padding: normalizeSize(24, true) }"
                >
                    <template #content>
                        <InfoBanner
                            v-if="shouldShowSharedSpaceWarning"
                            variant="warning"
                            :text="$t('experience.step4.sharedSpaceWarning.bannerMessage')"
                            class="ppv2-my-2 ppv2-mx-[5%]"
                        />
                        <!-- Contenu à afficher quand le switch est activé -->
                        <div
                            class="ppv2-my-2 ppv2-mx-[5%] ppv2-w-1/2 ppv2-min-h-[250px] ppv2-min-w-[200px] ppv2-border ppv2-border-black ppv2-border-opacity-50 ppv2-rounded-[12px]"
                        >
                            <h2
                                class="poppinsBold ppv2-my-4 ppv2-text-black ppv2-pt-6 ppv2-w-[70%] ppv2-mx-auto"
                                :style="{ fontSize: normalizeFontSize(15) }"
                            >
                                {{ $t('configuration.cards.schedule.title') }}
                            </h2>

                            <ul class="schedule-list ppv2-mb-2">
                                <li
                                    v-for="(day, i) in scheduleRecap"
                                    :key="i"
                                    class="evenItem poppinsLight ppv2-text-black ppv2-py-2"
                                    :style="{ fontSize: normalizeFontSize(12) }"
                                >
                                    <div class="ppv2-flex ppv2-justify-between ppv2-items-center ppv2-w-[70%] ppv2-mx-auto">
                                        <span>{{ $t('resource_planning.week_days.' + day.name.toLowerCase()) }} :</span>
                                        <span :class="{ closed: day.on }">
                                            <span v-if="day.nightFromPrev !== null" class="ppv2-block ppv2-opacity-60">
                                                {{ $t('experience.step4.multiMode.schedule.nightUntil') }}
                                                {{ minutesToHHMM(day.nightFromPrev) }}
                                            </span>
                                            <span v-if="day.on">
                                                <span v-for="(line, si) in dayScheduleLines(day)" :key="si" class="ppv2-block">
                                                    {{ line }}
                                                </span>
                                            </span>
                                            <span v-else>
                                                {{ $t('resource_planning.exceptions.exception_types.closed') }}
                                            </span>
                                        </span>
                                    </div>
                                </li>
                            </ul>

                            <div class="ppv2-flex ppv2-justify-center ppv2-items-center">
                                <BaseButton
                                    @click="showDialog = true"
                                    variant="secondary"
                                    class="ppv2-mt-2 ppv2-mb-6"
                                    :customFontSize="12"
                                >
                                    <Pencil :size="12" /> {{ $t('experience.step4.multiMode.schedule.btnEdit') }}
                                </BaseButton>
                            </div>

                            <PersonalizeSchedules v-model="showDialog" :days="days" @schedule-updated="handleScheduleUpdate" />
                        </div>
                    </template>
                </DashedCard>
            </div>

            <!-- Mode spécifique -->
            <div v-if="selectedOptionReservationMode === 'one_schedule_for_everyone'">
                <DashedCard
                    :title="$t('experience.step4.specificMode.disponibilityTitle')"
                    :title-size="15"
                    min-height="150px"
                    :margin-bottom="40"
                    :margin-top="70"
                    custom-class=""
                    :custom-style="{ padding: normalizeSize(32, true) }"
                    custom-class-title=""
                >
                    <template #content>
                        <template v-if="isEventCircuit">
                            <CalendarFull
                                ref="eventCalendar"
                                :subCategoryId="localPrestation && localPrestation.subcategory_id"
                                :establishmentId="establishmentId"
                                :prestation="localPrestation"
                                :externalEvents="events"
                                :externalCollisionCheck="eventCollisionCheck"
                                :disableInternalDialog="true"
                                @checked-dates-change="eventCheckedDates = $event"
                                @event-click="onEventCalendarEventClick"
                                @date-click="onEventCalendarDateClick"
                            />

                            <div v-if="eventCheckedDates.length > 0" class="ppv2-flex ppv2-justify-center ppv2-mt-4">
                                <BaseButton
                                    type="button"
                                    variant="secondary"
                                    :customHeight="43"
                                    :customFontSize="12"
                                    @click="openEventDialogFromCheckedDates"
                                >
                                    {{ $t('experience.planningModal.configureBtn') }}
                                </BaseButton>
                            </div>

                            <TimeSpecific
                                v-model="showEventDialog"
                                :key="eventDialogKey"
                                mode="disponibility"
                                :titlePopup="$t('experience.step4.specificMode.disponibilityTitle')"
                                :defaultTitle="$t('experience.step4.specificMode.popupTitleSection')"
                                :editing-data="eventEditingData"
                                :editing-index="eventEditingIndex"
                                :subCategoryId="localPrestation && localPrestation.subcategory_id"
                                :establishmentId="establishmentId"
                                :prestation="prestation"
                                :horaires_specifiques="eventsForDialog"
                                @save="onEventDialogSave"
                                @delete="onEventDialogDelete"
                                @cancel="onEventDialogCancel"
                            />
                        </template>
                        <ListHoraireSpecifique
                            v-else
                            :horaires_specifiques="computedHoraires"
                            :subCategoryId="localPrestation.subcategory_id"
                            :establishmentId="establishmentId"
                            :prestation="prestation"
                            @deleteSpecH="deleteSpecH"
                            @duplicateHoraireSpec="duplicateHoraireSpec"
                            @showDialog="showDialogTime"
                            @editHoraireSpe="editHoraireSpe"
                            @addSpeH="addSpeH"
                            @updateSpeH="updateSpeH"
                        >
                        </ListHoraireSpecifique>
                    </template>
                </DashedCard>
                <p v-if="errors.availabilities" class="ppv2-text-[#ed4b9e] ppv2-text-xs ppv2-mt-2 ppv2-mb-2">
                    {{ errors.availabilities }}
                </p>
            </div>

            <!-- Boutons -->
            <div class="form-actions" :class="{ '!ppv2-justify-end': this.complited }">
                <BackButton v-show="!this.complited" type="button" @click="$emit('previous-step')" />
                <BaseButton
                    id="submit"
                    type="submit"
                    @click="submitForm"
                    variant="primary"
                    :loading="loading"
                    :disabled="hasTierErrors"
                >
                    {{ !this.complited ? $t('experience.next') : $t('common.save') }}
                </BaseButton>
            </div>
        </div>

        <PreviewExperience :experience="{}" :activeField="activeField" :step="step" />

        <SharedSpaceWarningModal
            v-model="showSharedSpaceModal"
            :sharedSpaces="sharedSpacesData"
            @confirm="onSharedSpaceConfirm"
            @cancel="onSharedSpaceCancel"
        />
    </div>
</template>

<script>
import { Pencil, Plus, Settings, X, ChevronsUpDown, ChevronUp, ChevronDown } from 'lucide-vue'
import SelectableList from '../../../Shared/SelectableList.vue'
import ListHoraireSpecifique from './ListHoraireSpecifique.vue'
import ReservationPeriods from './ReservationPeriods.vue'
import HeaderStep from './HeaderStep.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import { formatDuration } from '../../../../utils/duration'
import PreviewExperience from './PreviewExperience.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BackButton from '../../../Shared/BackButton.vue'
import BaseButton from '../../../Shared/BaseButton.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import DashedCard from '../../../Shared/DashedCard.vue'
import PersonalizeSchedules from './PersonalizeSchedules.vue'
import ApiEstablishmentManager from '../../../../helpers/ApiEstablishmentManager'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'
import CustomButtonSave from '../../../Shared/CustomButtonSave.vue'
import CustomInput from '../../../Inputs/CustomInput.vue'
import { EventBus } from '../../../../eventBus'
import { SENTINEL_END_DATE } from '../../../../constants/planning'
import CalendarFull from '../../../Shared/CalendarFull.vue'
import TimeSpecific from './TimeSpecific.vue'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import InfoBanner from '../../../Shared/InfoBanner.vue'
import SharedSpaceWarningModal from './SharedSpaceWarningModal.vue'
import * as hours from '../../../../utils/scheduleHours'

export default {
    components: {
        CustomButtonSave,
        BaseButton,
        BackButton,
        BaseSelect,
        PreviewExperience,
        HeaderStep,
        Settings,
        Pencil,
        SelectableList,
        DashedCard,
        Plus,
        X,
        ChevronsUpDown,
        ChevronUp,
        ChevronDown,
        BaseSwitch,
        PersonalizeSchedules,
        CustomInput,
        ListHoraireSpecifique,
        CalendarFull,
        TimeSpecific,
        ReservationPeriods,
        InfoBanner,
        SharedSpaceWarningModal,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
        prestation: { type: Object, required: false },
        id: { type: [Number, String], default: null },
        selected_experience: { type: Object, required: false },
        category: {
            type: Object,
            required: false,
        },
        sub_category: {
            type: Object,
            required: false,
        },
        spaces_id: {
            type: Array,
            default: () => [],
        },
        complited: {
            type: Boolean,
            required: false,
        },
        token: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            activeField: null,
            establishmentId: 1,
            // Index des options dont le bloc « durées par nombre de personnes » est déplié.
            openTierPanels: [],
            // Id de la prestation pour laquelle les paliers déjà configurés ont été dépliés.
            // Le watcher `prestation` est deep+immediate : sans cette mémoire, il redéplierait
            // le panneau que l'utilisateur vient de refermer à chaque frappe ailleurs dans l'étape.
            tiersAutoOpenedForId: null,
            // Erreurs de paliers, indexées par index d'option puis index de palier.
            tierErrors: {},
            selectedOptionSpecifityHoraire: 0,
            showAdvancedParams: false,
            options_specifity_horaire: [
                {
                    label: this.$t('experience.step4.specifityHoraire.ResponseTitle1'),
                    value: 1,
                    subtitle: this.$t('experience.step4.specifityHoraire.Description1'),
                },
                {
                    label: this.$t('experience.step4.specifityHoraire.ResponseTitle2'),
                    value: 0,
                    subtitle: this.$t('experience.step4.specifityHoraire.Description2'),
                },
            ],
            options_interval_reservation: [],
            all_options_durations: [],
            options_durations_experience: [],
            selected_option_duree_experience: 120,
            options_duree_experience: [],
            isCustomSchedule: false,
            showDialog: false,
            days: [],
            isLoading: false,
            loading: false,
            error: null,
            localPrestation: null,
            hasCustomDuration: false,
            currentDuration: 0,
            add_start_time: null,
            cleaning_time: null,
            horaires_specifiques: [],
            events: [],
            personalise_horaire: [],
            errors: {},
            editingOptionIndex: null,
            optionNameDraft: '',
            eventCheckedDates: [],
            showEventDialog: false,
            eventEditingIndex: -1,
            eventDialogKey: 0,
            eventDialogFromChecked: false,
            eventEditingData: null,
            initialDataString: null,
            initialCustomScheduleString: null,
            initialCustomScheduleState: null,
            showSharedSpaceModal: false,
            sharedSpacesData: [],
            hasSharedSpaces: false,
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSizeVertical,
        normalizeSize,
        async checkSharedSpaces() {
            if (!this.localPrestation?.id) {
                return false
            }
            try {
                const { data } = await axios.get(`/api/v3/experience/${this.localPrestation.id}/shared-spaces`, {
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                this.hasSharedSpaces = data.has_shared_spaces
                this.sharedSpacesData = data.shared_spaces
                return data.has_shared_spaces
            } catch (err) {
                console.error('Error checking shared spaces:', err)
                return false
            }
        },
        onSharedSpaceConfirm() {
            this.showSharedSpaceModal = false
            this.$nextTick(() => {
                this.proceedWithSave()
            })
        },
        onSharedSpaceCancel() {
            this.showSharedSpaceModal = false
            if (this.initialCustomScheduleState) {
                this.selectedOptionSpecifityHoraire = this.initialCustomScheduleState.selectedOptionSpecifityHoraire
                this.days = JSON.parse(JSON.stringify(this.initialCustomScheduleState.days))
            }
        },
        async proceedWithSave() {
            const success = await this.saveExperience()
            if (success) {
                this.$toast.success(this.$t('experience.saved'))
                if (!this.complited) {
                    this.$emit('next-step')
                }
            }
        },
        getFormDataString() {
            return JSON.stringify({
                selected_interval_reservation: this.selected_interval_reservation,
                selected_duration_experience: this.selected_duration_experience,
                personilize_duration:
                    this.selected_duration_experience === -1 && this.personilize_duration > 0 ? this.personilize_duration : null,
                selected_option_duree_experience: this.selected_option_duree_experience,
                add_start_time: this.add_start_time,
                cleaning_time: this.cleaning_time,
                has_horaire_specefiq: this.selectedOptionSpecifityHoraire,
                days: this.days,
                selectedOptionReservationMode: this.selectedOptionReservationMode,
                dynamicDurationBlocks: this.dynamicDurationBlocks,
                horaires_specifiques: this.computedHoraires,
            })
        },
        hasChanges() {
            if (!this.initialDataString) return false
            return this.initialDataString !== this.getFormDataString()
        },
        getCustomScheduleString() {
            return JSON.stringify({
                selectedOptionSpecifityHoraire: this.selectedOptionSpecifityHoraire,
                days: this.days,
            })
        },
        captureInitialCustomScheduleState() {
            this.initialCustomScheduleState = {
                selectedOptionSpecifityHoraire: this.selectedOptionSpecifityHoraire,
                days: JSON.parse(JSON.stringify(this.days)),
            }
        },
        customScheduleHasChanges() {
            if (!this.initialCustomScheduleString) return false
            return this.initialCustomScheduleString !== this.getCustomScheduleString()
        },
        async handleScheduleUpdate(newSchedule) {
            const scheduleChanged = JSON.stringify(this.days) !== JSON.stringify(newSchedule)
            this.days = newSchedule.map((day) => ({ ...day, periods: [...day.periods], lunches: [...day.lunches] }))

            if (!scheduleChanged || !this.shouldCheckSharedSpaceWarning) {
                return
            }

            const hasShared = await this.checkSharedSpaces()
            if (hasShared) {
                this.showSharedSpaceModal = true
            }
        },
        // `day` est un jour du modèle UI (scheduleRecap) : fins > 24:00 libellées « le lendemain ».
        dayScheduleLines(day) {
            return (day.slots || []).map((slot) =>
                hours.formatSlotLabel(slot, this.$t('common.scheduleTime.nextDayShort'), ' - ')
            )
        },
        minutesToHHMM(minutes) {
            return hours.minutesToHHMM(minutes)
        },
        mapApiResponseToDays(apiData) {
            // Add null check
            if (!apiData || !Array.isArray(apiData)) {
                return this.initializeEmptyDays()
            }

            // Reorder days to start from Monday
            const dayMap = [
                { name: 'monday', label: this.$t('resource_planning.week_days.monday'), day: 1 }, // index 0 -> real day 1
                { name: 'tuesday', label: this.$t('resource_planning.week_days.tuesday'), day: 2 }, // index 1 -> real day 2
                { name: 'wednesday', label: this.$t('resource_planning.week_days.wednesday'), day: 3 }, // index 2 -> real day 3
                { name: 'thursday', label: this.$t('resource_planning.week_days.thursday'), day: 4 }, // index 3 -> real day 4
                { name: 'friday', label: this.$t('resource_planning.week_days.friday'), day: 5 }, // index 4 -> real day 5
                { name: 'saturday', label: this.$t('resource_planning.week_days.saturday'), day: 6 }, // index 5 -> real day 6
                { name: 'sunday', label: this.$t('resource_planning.week_days.sunday'), day: 0 }, // index 6 -> real day 0
            ]

            // Create a map of day number to day data
            const daysMap = new Map()
            apiData.forEach((item) => {
                // Fix for mapping (0=Sunday should go last)
                const adjustedDay = item.day === 0 ? 6 : item.day - 1
                const dayInfo = dayMap[adjustedDay]
                if (!dayInfo) return

                const period = {
                    start: item.start,
                    end: item.end,
                }

                // Treat '00:00'/'00:00' as no lunch break
                const hasLunch =
                    item.lunch_start && item.lunch_end && !(item.lunch_start === '00:00' && item.lunch_end === '00:00')
                const lunch = hasLunch
                    ? {
                          start: item.lunch_start,
                          end: item.lunch_end,
                      }
                    : null

                daysMap.set(adjustedDay, {
                    name: dayInfo.name,
                    label: dayInfo.label,
                    day: dayInfo.day,
                    enabled: item.is_open === 1,
                    close: item.is_open === 0,
                    periods: [period],
                    lunches: lunch ? [lunch] : [],
                })
            })

            // Return all days starting from Monday
            return dayMap.map((day, index) => {
                return (
                    daysMap.get(index) || {
                        name: day.name,
                        label: day.label,
                        enabled: false,
                        periods: [],
                        lunches: [],
                        close: false,
                    }
                )
            })
        },

        async fetchPlanningData() {
            this.isLoading = true
            this.error = null
            try {
                const response = await ApiEstablishmentManager.getDefaultScheduling(this.establishmentId)
                if (response && response.data) {
                    return this.mapApiResponseToDays(response.data)
                } else {
                    return this.initializeEmptyDays()
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.error = this.$t('experience.step4.reservationPeriods.errorFetch')
                return this.initializeEmptyDays()
            } finally {
                this.isLoading = false
            }
        },

        initializeEmptyDays() {
            const dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
            const dayNumbers = [1, 2, 3, 4, 5, 6, 0] // Days: 0=Sunday, 1=Monday, ..., 6=Saturday

            return dayNames.map((name, index) => ({
                name,
                day: dayNumbers[index],
                label: this.$t(`resource_planning.week_days.${name}`),
                enabled: true,
                periods: [{ start: '09:00', end: '18:00' }],
                lunches: [],
                close: false,
            }))
        },
        clearError(field) {
            if (this.errors[field]) {
                this.$delete(this.errors, field)
            }
        },
        onAdditionalBlockValueChange(originalIndex, newValue) {
            // Mettre à jour la valeur dans le store (dynamicDurationBlocks)
            const blocks = [...(this.dynamicDurationBlocks || [])]
            if (!blocks[originalIndex]) return

            blocks[originalIndex] = {
                ...blocks[originalIndex],
                value: Number(newValue),
                // Si on choisit une valeur standard, on annule la perso
                personilize: Number(newValue) === -1 ? blocks[originalIndex].personilize : null,
            }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
        },
        onAdditionalBlockCustomInput(originalIndex, rawValue) {
            // rawValue vient de CustomInput via @input
            const value = rawValue === '' ? '' : Number(rawValue)

            const blocks = [...(this.dynamicDurationBlocks || [])]
            if (!blocks[originalIndex]) return

            blocks[originalIndex] = {
                ...blocks[originalIndex],
                value: -1,
                personilize: value,
            }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)

            // Une nouvelle saisie efface l'erreur du champ. Aucune règle d'unicité : deux options
            // peuvent partager la même durée (le serveur revalide le reste).
            this.clearError(this.getCustomErrorKey(blocks[originalIndex], originalIndex))
        },
        initializeExperience(prestation) {
            if (this.hasId) {
                this.selected_interval_reservation = prestation.slot_config ?? null
                this.selected_duration_experience = prestation.duration
            }
            this.generateDurationOptions(prestation)
        },
        async saveExperience(redirect = false) {
            // Erreur bloquante : deux paliers d'une même option visant le même nombre de personnes.
            // Le serveur revalide la même règle (Step4Request) — ceci n'est qu'un garde d'interface.
            //
            // L'erreur ne s'affiche QUE dans le panneau de paliers : si l'utilisateur l'a replié,
            // il ne verrait rien du tout et le bouton paraîtrait mort. On déplie donc le panneau
            // fautif et on renseigne this.error, qui est rendu en haut de l'étape.
            const firstFaultyBlock = this.firstBlockWithTierError()
            if (firstFaultyBlock !== null) {
                if (!this.isTiersOpen(firstFaultyBlock)) {
                    this.openTierPanels.push(firstFaultyBlock)
                }
                this.error = this.$t('experience.tiers.blockingError')
                return false
            }

            this.loading = true
            this.error = null

            // ✅ FIX: Only send personilize_duration when custom duration is selected (-1)
            const formData = {
                selected_interval_reservation: this.selected_interval_reservation,
                selected_duration_experience: this.selected_duration_experience,
                personilize_duration:
                    this.selected_duration_experience === -1 && this.personilize_duration > 0 ? this.personilize_duration : null,
                selected_option_duree_experience: this.selected_option_duree_experience,
                add_start_time: this.add_start_time,
                cleaning_time: this.cleaning_time,
                step: this.step.id,
                selectExperience: this.localSelectExperience,
                has_horaire_specefiq: this.selectedOptionSpecifityHoraire,
                // store-derived reservation mode on the front.
                horaires_specifiques: this.computedHoraires.map((h) => ({
                    ...h,
                    lunchStart: h.lunchStart && /^\d{2}:\d{2}(:\d{2})?$/.test(h.lunchStart) ? h.lunchStart : null,
                    lunchEnd: h.lunchEnd && /^\d{2}:\d{2}(:\d{2})?$/.test(h.lunchEnd) ? h.lunchEnd : null,
                })),
                days:
                    this.selectedOptionSpecifityHoraire === 1
                        ? this.days.map((day) => {
                              const isClosed = day.close === true || day.enabled === false
                              return {
                                  ...day,
                                  // Si le jour est fermé, on n'envoie ni périodes ni pauses pour éviter
                                  // la validation backend (ex: start==end → "end doit être après start").
                                  periods: isClosed ? [] : day.periods || [],
                                  lunches: isClosed
                                      ? []
                                      : (day.lunches || []).filter((l) => l.start && l.end && l.start !== l.end),
                              }
                          })
                        : [],
                selectedOptionReservationMode: this.selectedOptionReservationMode,
                active: this.localPrestation?.active || false,
                // ✅ FIX: Clean personilize values in dynamic blocks - only send when value is -1 (custom)
                dynamicDurationBlocks: this.dynamicDurationBlocks.map((block) => ({
                    ...block,
                    personilize: block.value === -1 && block.personilize > 0 ? block.personilize : null,
                })),
            }
            if (this.localPrestation?.id) {
                formData.id = this.localPrestation.id
            }

            // Save the data strings after saving to reset changes
            this.initialDataString = JSON.stringify(formData)

            console.log('💾 Step4 - Saving with dynamicDurationBlocks:', this.dynamicDurationBlocks)
            console.log(
                '💾 Step4 - Block IDs being sent:',
                this.dynamicDurationBlocks.map((b) => ({ id: b.id, value: b.value, price: b.price }))
            )

            try {
                const object = await axios.post('/api/v3/experience/save_exit_step_two', formData)
                this.$emit('update-prestation', object.data.data)
                this.initialCustomScheduleString = this.getCustomScheduleString()
                this.captureInitialCustomScheduleState()

                if (redirect) {
                    window.location.href = this.redirectUrl
                }
                return true // ✅ Success - allow navigation to next step
            } catch (err) {
                console.error('❌ Step4 - Error saving:', err.response || err)

                // ✅ FIX: Handle 422 validation errors specifically
                if (err.response?.status === 422 && err.response?.data?.errors) {
                    // Populate errors object with validation errors
                    this.errors = err.response.data.errors
                    this.error = err.response.data.message || this.$t('common.formValidationError')
                } else {
                    // Generic error message for 500 or other errors
                    this.error = err.response?.data?.message || this.$t('experience.errors.save')
                }

                return false // ✅ Block navigation on error
            } finally {
                this.loading = false
            }
        },
        async saveAndExit() {
            this.$emit('save-and-exit')
        },
        async submitForm() {
            // ✅ FIX: Reset ALL errors (clears stale backend keys from previous 422)
            this.errors = {}
            this.error = null

            if (this.selectedOptionReservationMode === 'multiple_time_slots') {
                // Check if interval is selected
                if (!this.selected_interval_reservation) {
                    this.error = this.$t('experience.errors.selectInterval')
                }
                // Check if duration is selected — auto-fill and inform user
                if (this.selected_duration_experience === null || this.selected_duration_experience === undefined) {
                    this.$set(this.errors, 'duration', this.$t('experience.errors.selectDuration'))
                }
                // Only validate personilize_duration if custom duration is selected (-1)
                if (this.selected_duration_experience === -1 && (!this.personilize_duration || this.personilize_duration <= 0)) {
                    this.$set(this.errors, 'personilize_duration', this.$t('experience.errors.required'))
                } else {
                    this.$delete(this.errors, 'personilize_duration')
                }
            }

            // Validate availabilities are required for event mode
            if (this.selectedOptionReservationMode === 'one_schedule_for_everyone') {
                if (!this.computedHoraires || this.computedHoraires.length === 0) {
                    this.$set(this.errors, 'availabilities', this.$t('experience.errorDisponibility'))
                }
            }

            if (Object.keys(this.errors).length === 0 && !this.error) {
                await this.proceedWithSave()
            }
        },
        getState(field) {
            if (this.errors[field]) return 'error'
            return 'default'
        },
        generateDurationOptions(prestation) {
            // build full list into all_options_durations
            if (!this.hasId) {
                this.all_options_durations = Array.from({ length: (180 - 15) / 15 + 1 }, (_, i) => ({
                    label: `${15 + i * 15} (${this.$t('common.min')})`,
                    value: 15 + i * 15,
                }))
            } else {
                if (prestation && prestation.slot_config > 0) {
                    const step = prestation.slot_config
                    const max = prestation.max_duration_config
                    this.all_options_durations = Array.from({ length: Math.floor((max - step) / step) + 1 }, (_, i) => ({
                        label: `${step + i * step} (${this.$t('common.min')})`,
                        value: step + i * step,
                    }))
                } else {
                    this.all_options_durations = []
                }
            }
            // always keep custom option
            this.all_options_durations.push({
                label: this.$t('experience.step4.custom_duration.title'),
                value: -1,
            })
            // keep a copy in options_durations_experience for backward compatibility
            this.options_durations_experience = [...this.all_options_durations]

            this.personilize_duration = this.maxDuration + this.minDuration
            console.log('personilize_duration', this.personilize_duration)

            if (this.hasId && prestation) {
                const existsInOptions = this.options_durations_experience.some((opt) => opt.value === prestation.duration)

                if (prestation.duration == null) {
                    this.selected_duration_experience = null
                    this.personilize_duration = this.maxDuration + this.minDuration
                } else {
                    if (existsInOptions) {
                        this.selected_duration_experience = prestation.duration
                        this.personilize_duration = this.maxDuration + this.minDuration
                    } else {
                        this.selected_duration_experience = -1
                        this.personilize_duration = prestation.duration ?? 0
                    }
                }
            }
        },
        getCurrentFormState() {
            return {
                selected_interval_reservation: this.selected_interval_reservation,
                selected_duration_experience: this.selected_duration_experience,
                selected_option_duree_experience: this.selected_option_duree_experience,
                days: JSON.stringify(this.days), // deep compare via string
            }
        },

        exit() {
            window.location.href = this.redirectUrl
        },
        formatDateFr(dateStr) {
            const options = { day: 'numeric', month: 'long', year: 'numeric' }
            return new Date(dateStr).toLocaleDateString('fr-FR', options)
        },
        getDaysBetween(startDate, endDate, lang) {
            const weekdaysMap = {
                fr: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            }
            const weekdays = weekdaysMap[lang] || weekdaysMap.en

            // No end date: return all weekdays
            if (!endDate) {
                return weekdays.slice(1).concat(weekdays[0]).join(', ')
            }

            const days = []
            let currentDate = new Date(startDate)
            const end = new Date(endDate)

            while (currentDate <= end) {
                days.push(weekdays[currentDate.getDay()])
                currentDate.setDate(currentDate.getDate() + 1)
            }

            return [...new Set(days)].join(', ')
        },
        showDialogTime() {
            this.showDialog = true
        },
        deleteSpecH(index) {
            this.computedHoraires.splice(index, 1)
        },
        duplicateHoraireSpec(horaire_spe, index) {
            const duplicated = { ...horaire_spe, tmp_id: Date.now() }
            this.computedHoraires.splice(index + 1, 0, duplicated)
        },
        updateSpeH(index, data) {
            this.$set(this.computedHoraires, index, data)
        },
        addSpeH(data) {
            this.computedHoraires.push(data)
        },
        editHoraireSpe(horaire, index) {
            // Edit specific schedule
        },
        openEventDialogFromCheckedDates() {
            const sorted = [...this.eventCheckedDates].sort()
            const dateStart = sorted[0]
            const dateEnd = sorted[sorted.length - 1]
            const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            const selectedDays = [...new Set(sorted.map((d) => dayNames[new Date(d).getDay()]))]

            const matchedIndex = this.events.findIndex((ev) => {
                const evStart = ev.dateStart
                const evEnd = ev.dateEnd || ev.dateStart
                return evStart <= dateEnd && dateStart <= evEnd
            })

            if (matchedIndex >= 0) {
                const existing = this.events[matchedIndex]
                this.eventEditingData = {
                    ...existing,
                    dateStart,
                    dateEnd,
                    selectedDays,
                }
            } else {
                this.eventEditingData = {
                    dateStart,
                    dateEnd,
                    selectedDays,
                    timeStart: '08:00',
                    timeEnd: '18:00',
                }
            }
            this.eventEditingIndex = -1

            this.eventDialogFromChecked = true
            this.showEventDialog = false
            this.eventDialogKey += 1
            this.$nextTick(() => {
                this.showEventDialog = true
            })
        },
        onEventCalendarDateClick(info) {
            // Direct click on a day cell opens the config dialog for that single date,
            // unless the user is mid checkbox-selection (the click must not hijack it).
            if (this.eventCheckedDates.length > 0) return
            const dateStr = typeof info.dateStr === 'string' ? info.dateStr.substring(0, 10) : null
            if (!dateStr) return
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            if (new Date(dateStr) < today) return

            this.eventCheckedDates = [dateStr]
            if (this.$refs.eventCalendar?.setCheckedDates) {
                this.$refs.eventCalendar.setCheckedDates([dateStr])
            }
            this.openEventDialogFromCheckedDates()
        },
        onEventCalendarEventClick(info) {
            const tmpId = info.event?.id
            const index = this.events.findIndex((e) => String(e.tmp_id) === String(tmpId) || String(e.id) === String(tmpId))
            if (index < 0) return
            this.eventEditingData = { ...this.events[index] }
            this.eventEditingIndex = index
            this.eventDialogFromChecked = false
            this.showEventDialog = false
            this.eventDialogKey += 1
            this.$nextTick(() => {
                this.showEventDialog = true
            })
        },
        groupContiguousDates(sortedDates) {
            if (!sortedDates.length) return []
            const groups = []
            let current = [sortedDates[0]]
            for (let i = 1; i < sortedDates.length; i++) {
                const prev = new Date(current[current.length - 1])
                const curr = new Date(sortedDates[i])
                const diffDays = Math.round((curr - prev) / 86400000)
                if (diffDays === 1) {
                    current.push(sortedDates[i])
                } else {
                    groups.push(current)
                    current = [sortedDates[i]]
                }
            }
            groups.push(current)
            return groups
        },
        expandDateRangeWithDays(start, end, selectedDays) {
            const dayMap = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 }
            const allowedDows = (selectedDays || []).map((d) => dayMap[d]).filter((x) => x !== undefined)
            const result = []
            if (!start || !end) return result
            const d = new Date(start)
            const endD = new Date(end)
            while (d <= endD) {
                // An explicitly empty selectedDays means "no dates" (dates were deselected → delete).
                // Callers that want "all days" pass the full day list upstream (creation default).
                if (allowedDows.includes(d.getDay())) {
                    const y = d.getFullYear()
                    const m = String(d.getMonth() + 1).padStart(2, '0')
                    const day = String(d.getDate()).padStart(2, '0')
                    result.push(`${y}-${m}-${day}`)
                }
                d.setDate(d.getDate() + 1)
            }
            return result
        },
        onEventDialogSave(data) {
            const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

            if (this.eventDialogFromChecked && this.eventCheckedDates.length > 0) {
                const origSorted = [...this.eventCheckedDates].sort()
                const origStart = origSorted[0]
                const origEnd = origSorted[origSorted.length - 1]
                const originalCheckedSet = new Set(this.eventCheckedDates)

                const popupStart = data.dateStart
                const popupEnd = data.dateEnd || data.dateStart
                const popupDates = this.expandDateRangeWithDays(popupStart, popupEnd, data.selectedDays)

                const finalDates = popupDates.filter((d) => {
                    if (d >= origStart && d <= origEnd) {
                        return originalCheckedSet.has(d)
                    }
                    return true
                })

                const finalSorted = [...finalDates].sort()

                // Remove entries covering any originally-checked date AND any final date, then re-add
                // finalSorted. Covering origSorted deletes dates the user deselected (e.g. all days
                // unchecked); covering finalSorted avoids leaving a duplicate when the range is widened
                // onto a date that already had an event. (A loaded multi-day range covering one of these
                // dates is removed in full and re-added per finalDate.)
                this.removeEventsCoveringDates([...new Set([...origSorted, ...finalSorted])])

                // finalSorted may be empty (the date(s) were removed) → nothing re-added → deletion.
                for (const dateStr of finalSorted) {
                    const dayName = dayNames[new Date(dateStr).getDay()]
                    const enriched = {
                        ...data,
                        dateStart: dateStr,
                        dateEnd: dateStr,
                        selectedDays: [dayName],
                        tmp_id: Date.now() + Math.random(),
                        label: `${this.$t('common.from')} ${this.formatEventDateFr(dateStr)}`,
                        hours: `${data.timeStart} – ${data.timeEnd}`,
                    }
                    this.events.push(enriched)
                }

                this.eventCheckedDates = [...finalSorted]
                if (this.$refs.eventCalendar?.setCheckedDates) {
                    this.$refs.eventCalendar.setCheckedDates(finalSorted)
                }
                this.$nextTick(() => {
                    if (this.$refs.eventCalendar?.refresh) {
                        this.$refs.eventCalendar.refresh()
                    }
                })
            } else if (this.eventEditingIndex >= 0 && (!data.selectedDays || data.selectedDays.length === 0)) {
                // Editing an existing single event and clearing all day chips = delete it (mirror the
                // checked-dates branch); otherwise a phantom row with selectedDays:[] would be persisted.
                this.events.splice(this.eventEditingIndex, 1)
            } else {
                const enriched = {
                    ...data,
                    label: !data.dateEnd
                        ? `${this.$t('common.from')} ${this.formatEventDateFr(data.dateStart)}`
                        : `${this.$t('common.from')} ${this.formatEventDateFr(data.dateStart)} ${this.$t(
                              'common.to_date'
                          )} ${this.formatEventDateFr(data.dateEnd)}`,
                    hours: `${data.timeStart} – ${data.timeEnd}`,
                }
                if (this.eventEditingIndex >= 0) {
                    this.$set(this.events, this.eventEditingIndex, enriched)
                } else {
                    this.events.push(enriched)
                }
            }

            this.eventEditingData = null
            this.eventEditingIndex = -1
        },
        onEventDialogCancel() {
            this.eventEditingData = null
            this.eventEditingIndex = -1
        },
        // Remove every event entry that covers any of the given dates (shared by the
        // "uncheck all days = delete" save path and the explicit delete button).
        removeEventsCoveringDates(dates) {
            if (!dates || !dates.length) return
            const removeIdx = this.events
                .map((ev, idx) => {
                    const evStart = ev.dateStart
                    const evEnd = ev.dateEnd || ev.dateStart
                    return dates.some((d) => evStart <= d && d <= evEnd) ? idx : -1
                })
                .filter((idx) => idx >= 0)
                .sort((a, b) => b - a)
            for (const idx of removeIdx) {
                this.events.splice(idx, 1)
            }
        },
        onEventDialogDelete() {
            if (this.eventDialogFromChecked && this.eventCheckedDates.length > 0) {
                this.removeEventsCoveringDates([...this.eventCheckedDates])
                this.eventCheckedDates = []
                if (this.$refs.eventCalendar?.setCheckedDates) {
                    this.$refs.eventCalendar.setCheckedDates([])
                }
            } else if (this.eventEditingIndex >= 0) {
                this.events.splice(this.eventEditingIndex, 1)
            }
            this.eventEditingData = null
            this.eventEditingIndex = -1
            this.showEventDialog = false
            this.$nextTick(() => {
                if (this.$refs.eventCalendar?.refresh) {
                    this.$refs.eventCalendar.refresh()
                }
            })
        },
        formatEventDateFr(dateStr) {
            const options = { day: 'numeric', month: 'long', year: 'numeric' }
            return new Date(dateStr).toLocaleDateString(this.$i18n.locale === 'fr' ? 'fr-FR' : 'en-US', options)
        },
        eventCollisionCheck() {
            return false
        },
        getUserChoiceValue(key) {
            if (!this.prestation || !this.prestation.user_choices) return null
            const choice = this.prestation.user_choices.find((c) => c.key === key)
            return choice ? choice.value : null
        },
        isChoiceEditable(key) {
            if (!this.prestation || !this.prestation.user_choices) return true
            const choice = this.prestation.user_choices.find((c) => c.key === key)
            if (choice) {
                return choice.can_update == 1 || choice.can_update === true
            }
            return true
        },
        addDurationBlock() {
            // Défaut : la première durée de la grille (une durée déjà utilisée est permise).
            // `id: null` = nouvelle option. Jamais d'id fabriqué (ex. Date.now()) : le serveur
            // identifie les options par id, un faux id ne doit jamais pouvoir en viser une.
            const availableOptions = this.getFilteredDurations()
            const firstOption = availableOptions.find((opt) => opt.value !== undefined && opt.value !== -1)
            const defaultValue = firstOption ? Number(firstOption.value) : -1
            const nextOptionName = this.getDefaultOptionName(this.durationOptionBlocks.length)

            // if first option is -1 (custom), create block with value -1 and copy current personilize_duration to block.personilize
            if (defaultValue === -1) {
                this.$store.dispatch('experience/addDynamicDurationBlock', {
                    id: null,
                    value: -1,
                    price: 0,
                    personilize: Number(this.personilize_duration) || 0,
                    name: nextOptionName,
                })
            } else {
                // otherwise push the numeric value
                this.$store.dispatch('experience/addDynamicDurationBlock', {
                    id: null,
                    value: defaultValue,
                    price: 0,
                    personilize: null,
                    name: nextOptionName,
                })
            }
        },
        // ---------------------------------------------------------------------------------------
        // Paliers : nombre de personnes -> durée. Même donnée que l'étape Tarification (qui y ajoute
        // le prix) : tout est écrit dans dynamicDurationBlocks[].prices_degressif, la seule source.
        // ---------------------------------------------------------------------------------------
        isTiersOpen(blockIndex) {
            return this.openTierPanels.includes(blockIndex)
        },
        /**
         * Déplie, UNE SEULE FOIS par expérience chargée, les options qui portent déjà des paliers.
         *
         * L'appelant est le watcher `prestation`, qui est deep+immediate : sans la garde par id,
         * chaque mutation du formulaire rouvrirait un panneau que l'utilisateur vient de refermer.
         *
         * On exige un palier RENSEIGNÉ (personnes ou durée) et non une simple ligne présente :
         * une ligne vide laissée par une manipulation ne doit rien déplier.
         */
        autoOpenConfiguredTiers(prestationId, blocks) {
            if (!prestationId || this.tiersAutoOpenedForId === prestationId) return

            const configured = (blocks || []).reduce((indexes, block, index) => {
                const hasValue = (block.prices_degressif || []).some((tier) => tier && (tier.persons || tier.duration))
                if (hasValue) indexes.push(index)
                return indexes
            }, [])

            this.openTierPanels = [...new Set([...this.openTierPanels, ...configured])]
            this.tiersAutoOpenedForId = prestationId

            // Valider DÈS l'ouverture : le bouton Suivant est désactivé sur erreur de palier, donc
            // une donnée invalide déjà en base doit se voir immédiatement — sinon l'utilisateur
            // arrive devant un bouton mort, sans message et éventuellement panneau replié.
            this.$nextTick(() => {
                const faulty = this.firstBlockWithTierError()
                if (faulty !== null && !this.isTiersOpen(faulty)) {
                    this.openTierPanels.push(faulty)
                }
            })
        },
        toggleTiers(blockIndex) {
            const position = this.openTierPanels.indexOf(blockIndex)
            if (position === -1) {
                this.openTierPanels.push(blockIndex)
            } else {
                this.openTierPanels.splice(position, 1)
            }
        },
        /** Écrit un champ de palier dans le store, en préservant l'immutabilité des blocs. */
        updateTier(blockIndex, tierIndex, field, value) {
            const blocks = [...(this.dynamicDurationBlocks || [])]
            const block = blocks[blockIndex]
            if (!block) return

            const tiers = [...(block.prices_degressif || [])]
            tiers[tierIndex] = { ...tiers[tierIndex], [field]: value }
            blocks[blockIndex] = { ...block, prices_degressif: tiers }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
            this.validateTiers(blockIndex)
        },
        addTier(blockIndex) {
            const blocks = [...(this.dynamicDurationBlocks || [])]
            const block = blocks[blockIndex]
            if (!block) return

            const tiers = [...(block.prices_degressif || [])]
            // Premier effectif libre, pour ne pas créer un doublon en erreur dès l'ajout.
            const used = new Set(tiers.map((tier) => Number(tier.persons)).filter((value) => value > 0))
            let persons = used.size > 0 ? Math.max(...used) + 1 : 1
            while (used.has(persons)) persons += 1

            tiers.push({ persons, duration: '', price: '', editing: false })
            blocks[blockIndex] = { ...block, prices_degressif: tiers }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
        },
        removeTier(blockIndex, tierIndex) {
            const blocks = [...(this.dynamicDurationBlocks || [])]
            const block = blocks[blockIndex]
            if (!block) return

            const tiers = [...(block.prices_degressif || [])]
            tiers.splice(tierIndex, 1)
            blocks[blockIndex] = { ...block, prices_degressif: tiers }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
            this.validateTiers(blockIndex)
        },
        /**
         * Deux paliers d'une même option ne peuvent pas viser le même nombre de personnes :
         * la résolution serveur (« le plus grand nb <= N ») deviendrait non déterministe.
         * Erreur BLOQUANTE, également revalidée côté serveur (frontend = zéro confiance).
         */
        /**
         * Valide les paliers d'une option.
         *
         * Les erreurs sont indexées PAR CHAMP (`{ persons, duration }`) et non par palier : c'est la
         * seule façon de poser le message sous la bonne case. Un message flottant au-dessus de la
         * ligne n'indique pas quoi corriger.
         *
         * La durée n'est exigée QUE si le champ est affiché (durée dynamique active). Sans cette
         * condition, les ~190 paliers purement tarifaires de vr/paintball/booking — dont la durée
         * égale celle de leur option, donc vide à l'écran — deviendraient tous invalides et
         * bloqueraient l'enregistrement de leurs expériences.
         */
        validateTiers(blockIndex) {
            const block = (this.dynamicDurationBlocks || [])[blockIndex]
            const tiers = (block && block.prices_degressif) || []
            const errors = {}
            const seen = new Map()

            tiers.forEach((tier, tierIndex) => {
                const fieldErrors = {}
                const persons = Number(tier.persons)

                // « Nbr. de pers. » est requis (le serveur le refuse aussi) : le signaler ici, sous
                // le champ, plutôt que de laisser partir une 422 rendue en bannière générique.
                if (!persons) {
                    fieldErrors.persons = this.$t('experience.errors.requiredNbrParticipant')
                } else if (seen.has(persons)) {
                    fieldErrors.persons = this.$t('experience.tiers.duplicatePersons', {
                        persons,
                        palier: seen.get(persons) + 1,
                    })
                } else {
                    seen.set(persons, tierIndex)
                }

                if (this.hasDynamicDuration) {
                    const durationError = this.tierDurationError(tier)
                    if (durationError) fieldErrors.duration = durationError
                }

                if (Object.keys(fieldErrors).length > 0) {
                    errors[tierIndex] = fieldErrors
                }
            })

            this.$set(this.tierErrors, blockIndex, errors)
        },
        /** La règle de durée, énoncée une fois. Renvoie le message ou null. */
        tierDurationError(tier) {
            const selected = tier?.duration

            if (selected === '' || selected === null || selected === undefined) {
                return this.$t('experience.tiers.durationRequired')
            }

            // « Personnalisée » : la valeur réelle vit dans `personilize`.
            const value = Number(selected) === -1 ? Number(tier.personilize) : Number(selected)

            if (!Number.isFinite(value) || value <= 0) {
                return this.$t('experience.tiers.durationInvalid')
            }

            return null
        },
        /** Message d'erreur d'UN champ d'un palier ('persons' ou 'duration'). */
        getTierError(blockIndex, tierIndex, field = 'persons') {
            return this.tierErrors?.[blockIndex]?.[tierIndex]?.[field] || ''
        },
        getTierState(blockIndex, tierIndex, field = 'persons') {
            return this.getTierError(blockIndex, tierIndex, field) ? 'error' : ''
        },
        /**
         * Index du premier bloc portant un palier en erreur, ou null. Revalide tout au passage.
         * On renvoie l'INDEX et non un booléen, pour pouvoir déplier le panneau concerné.
         */
        firstBlockWithTierError() {
            // Case décochée : le bloc est masqué, donc une erreur y serait invisible et bloquerait
            // l'enregistrement en silence. On ne valide que ce que l'utilisateur peut voir.
            if (!this.hasDynamicDuration) {
                return null
            }

            const blocks = this.dynamicDurationBlocks || []
            blocks.forEach((_, blockIndex) => this.validateTiers(blockIndex))

            for (let blockIndex = 0; blockIndex < blocks.length; blockIndex += 1) {
                if (Object.keys(this.tierErrors?.[blockIndex] || {}).length > 0) {
                    return blockIndex
                }
            }

            return null
        },
        removeDurationBlock(index) {
            // Keep first block as main duration source to preserve legacy behavior.
            if (index === 0) return

            this.$store.dispatch('experience/removeDynamicDurationBlock', index)

            // openTierPanels stocke des index POSITIONNELS, et durationOptionBlocks recalcule
            // originalIndex par position : sans ce remappage, supprimer une option décale tous les
            // index suivants et un panneau ouvert se retrouve rattaché à la mauvaise option.
            this.openTierPanels = this.openTierPanels
                .filter((openIndex) => openIndex !== index)
                .map((openIndex) => (openIndex > index ? openIndex - 1 : openIndex))

            // Les erreurs de paliers sont indexées de la même façon : même décalage à appliquer.
            const remappedErrors = {}
            Object.entries(this.tierErrors || {}).forEach(([key, value]) => {
                const errorIndex = Number(key)
                if (errorIndex === index) return
                remappedErrors[errorIndex > index ? errorIndex - 1 : errorIndex] = value
            })
            this.tierErrors = remappedErrors

            // Erreurs « durée personnalisée » des options (clés serveur `dynamicDurationBlocks.{i}.personilize`) :
            // même décalage positionnel.
            const personilizeKey = /^dynamicDurationBlocks\.(\d+)\.personilize$/
            const remappedFieldErrors = {}
            Object.entries(this.errors || {}).forEach(([key, value]) => {
                const match = key.match(personilizeKey)
                if (!match) {
                    remappedFieldErrors[key] = value
                    return
                }
                const errorIndex = Number(match[1])
                if (errorIndex === index) return
                remappedFieldErrors[this.getCustomErrorKey(null, errorIndex > index ? errorIndex - 1 : errorIndex)] = value
            })
            this.errors = remappedFieldErrors
        },
        getDefaultOptionName(optionIndex) {
            return `${this.$t('experience.step4.optionDuration.optionPrefix')} ${optionIndex + 1}`
        },
        getOptionName(block, optionIndex) {
            if (block && typeof block.name === 'string' && block.name.trim()) {
                const cleanedName = block.name.trim()
                // Keep default labels when backend falls back to prestation name.
                if (!this.localPrestation?.name || cleanedName !== this.localPrestation.name) {
                    return cleanedName
                }
            }
            return this.getDefaultOptionName(optionIndex)
        },
        startEditingOptionName(originalIndex, optionIndex) {
            const block = (this.dynamicDurationBlocks || [])[originalIndex]
            this.editingOptionIndex = originalIndex
            this.optionNameDraft = this.getOptionName(block, optionIndex)
        },
        saveOptionName(originalIndex, optionIndex) {
            const blocks = [...(this.dynamicDurationBlocks || [])]
            if (!blocks[originalIndex]) {
                this.editingOptionIndex = null
                this.optionNameDraft = ''
                return
            }

            const cleanName = (this.optionNameDraft || '').trim() || this.getDefaultOptionName(optionIndex)
            blocks[originalIndex] = {
                ...blocks[originalIndex],
                name: cleanName,
            }

            this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
            this.editingOptionIndex = null
            this.optionNameDraft = ''
        },
        // Clé d'erreur du champ « Personnalisée » d'une option : positionnelle (les nouvelles options
        // n'ont pas d'id) et IDENTIQUE à la clé du 422 serveur (Step4Request), pour que l'erreur
        // renvoyée s'affiche sous le bon champ.
        // eslint-disable-next-line no-unused-vars
        getCustomErrorKey(block, originalIndex) {
            if (originalIndex === 0) {
                return 'personilize_duration'
            }

            return `dynamicDurationBlocks.${originalIndex}.personilize`
        },
    },
    computed: {
        // Récap des horaires spécifiques : lit la paire D 23:59 / D+1 00:00 + pause comme un
        // créneau nocturne rattaché au jour D (voir utils/scheduleHours.js).
        scheduleRecap() {
            return hours.parseWeek(this.days || [])
        },
        hasId() {
            return this.id !== null && this.id !== undefined
        },
        shouldShowSharedSpaceWarning() {
            return this.shouldCheckSharedSpaceWarning && this.hasSharedSpaces
        },
        shouldCheckSharedSpaceWarning() {
            return this.hasId && this.selectedOptionSpecifityHoraire === 1 && this.customScheduleHasChanges()
        },
        localSelectExperience() {
            return this.selected_experience || {}
        },
        filteredOptionsDurations() {
            return this.getFilteredDurations()
        },
        // 🔵 Read reservation mode from store
        reservationModeFromStore() {
            return this.$store.getters['experience/selectedReservationMode']
        },
        selectedOptionReservationMode() {
            return this.$store.getters['experience/reservationMode']
        },
        // Base URL for redirects
        baseUrl() {
            return `${window.location.protocol}//${window.location.host}`
        },
        // Redirect URL based on experience type
        redirectUrl() {
            return `${this.baseUrl}/back-office/v3/experience`
        },
        // Valid durations (reused in multiple places)
        validDurations() {
            return this.options_durations_experience.map((opt) => opt.value).filter((v) => v > 0)
        },
        // Max duration
        maxDuration() {
            return this.validDurations.length ? Math.max(...this.validDurations) : null
        },
        // Min duration
        minDuration() {
            return this.validDurations.length ? Math.min(...this.validDurations) : null
        },
        // Dynamic duration blocks from store
        dynamicDurationBlocks() {
            return this.$store.getters['experience/dynamicDurationBlocks']
        },
        // Selected interval reservation from store
        selected_interval_reservation: {
            get() {
                return this.$store.getters['experience/selected_interval_reservation']
            },
            set(value) {
                this.$store.dispatch('experience/setSelectedIntervalReservation', value)
            },
        },
        // Selected duration is the first element of dynamicDurationBlocks
        selected_duration_experience: {
            get() {
                const blocks = this.$store.getters['experience/dynamicDurationBlocks']
                if (!blocks || blocks.length === 0) return null

                const firstBlock = blocks[0]
                // Return value or personilize if custom duration
                return firstBlock.value === -1 ? -1 : firstBlock.value
            },
            set(value) {
                const blocks = [...(this.$store.getters['experience/dynamicDurationBlocks'] || [])]

                if (blocks.length === 0) {
                    // Create first block
                    blocks.push({
                        id: null,
                        value: value,
                        price: '',
                        personilize: null,
                    })
                } else {
                    // Update first block
                    blocks[0] = {
                        ...blocks[0],
                        value: value,
                    }
                }

                console.log('🔄 Step4 - blocks:', blocks)

                this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
            },
        },
        personilize_duration: {
            get() {
                const blocks = this.$store.getters['experience/dynamicDurationBlocks']
                if (!blocks || blocks.length === 0) return 0
                return blocks[0].personilize || 0
            },
            set(value) {
                const blocks = [...(this.$store.getters['experience/dynamicDurationBlocks'] || [])]
                if (blocks.length > 0) {
                    blocks[0] = {
                        ...blocks[0],
                        personilize: value === '' ? null : Number(value),
                    }
                    this.$store.dispatch('experience/setDynamicDurationBlocks', blocks)
                }
            },
        },
        // Filtered durations from store
        getFilteredDurations() {
            return (excludeCurrentValue = null) => {
                return this.$store.getters['experience/getFilteredDurations'](
                    excludeCurrentValue,
                    this.selected_duration_experience
                )
            }
        },
        // Durées proposées pour un PALIER : la grille complète + « Personnalisée », sans exclusion.
        getTierDurationOptions() {
            return () => this.$store.getters['experience/getTierDurationOptions']()
        },
        /**
         * Vrai dès qu'un palier est en erreur. Pilote la désactivation du bouton Suivant.
         *
         * Fonctionne parce que la validation tourne à CHAQUE saisie (updateTier) ET à l'hydratation
         * — sans quoi l'utilisateur arriverait devant un bouton mort sans savoir pourquoi.
         */
        hasTierErrors() {
            return Object.values(this.tierErrors || {}).some((blockErrors) => Object.keys(blockErrors || {}).length > 0)
        },
        // Les paliers de DURÉE n'existent que pour un bowling : la case « durée dynamique » (étape
        // Espaces) est ce qui les déverrouille. Les paliers TARIFAIRES, eux, restent disponibles
        // partout — ils vivent à l'étape Tarification.
        hasDynamicDuration() {
            return Boolean(this.$store.getters['experience/userSelections']?.dynamic_duration_enabled)
        },
        durationOptionBlocks() {
            const blocks = this.$store.getters['experience/dynamicDurationBlocks']
            return blocks.map((block, originalIndex) => ({ ...block, originalIndex }))
        },
        computedHoraires() {
            // Detect event mode by the reservation_mode user-choice KEY (not user_choices[0], whose order
            // is not guaranteed) so the event schedule is read from this.events reliably (PLPRB-1084 review).
            return this.getUserChoiceValue('reservation_mode') === 'one_schedule_for_everyone'
                ? this.events
                : this.horaires_specifiques
        },
        matchingCircuits() {
            return this.$store.getters['experience/getMatchingCircuits']
        },
        isEventCircuit() {
            return this.matchingCircuits.length === 1 && this.matchingCircuits[0] === 'event'
        },
        eventsForDialog() {
            if (!this.eventDialogFromChecked || !this.eventCheckedDates.length) {
                return this.events
            }
            const sorted = [...this.eventCheckedDates].sort()
            const dateStart = sorted[0]
            const dateEnd = sorted[sorted.length - 1]
            return this.events.filter((ev) => {
                const evStart = ev.dateStart
                const evEnd = ev.dateEnd || ev.dateStart
                const overlaps = evStart <= dateEnd && dateStart <= evEnd
                return !overlaps
            })
        },
    },
    watch: {
        // �🔥 Reactively update experience when prestation changes
        prestation: {
            handler(newVal) {
                if (newVal) {
                    console.log('🔄 Step4 - prestation updated:', newVal)
                    console.log('🔄 Step4 - prestation.user_choices:', newVal.user_choices)
                    this.localPrestation = newVal
                    this.add_start_time = newVal.add_start_time != null ? newVal.add_start_time : null
                    this.cleaning_time = newVal.cleaning_time != null ? newVal.cleaning_time : null
                    this.showAdvancedParams =
                        (this.add_start_time != null && this.add_start_time !== 0) ||
                        (this.cleaning_time != null && this.cleaning_time !== 0)

                    // Initialize interval reservation FIRST
                    if (newVal.slot_config) {
                        this.$store.dispatch('experience/setSelectedIntervalReservation', newVal.slot_config)
                    } else {
                        this.$store.dispatch('experience/setSelectedIntervalReservation', null)
                    }

                    // Wait for next tick to ensure interval is set
                    this.$nextTick(() => {
                        // Initialize ALL durations (including main) in dynamicDurationBlocks
                        if (newVal.prices_by_times && newVal.prices_by_times.length > 0) {
                            const interval = newVal.slot_config || 10

                            // Map ALL prices_by_times to dynamicDurationBlocks
                            const allBlocks = newVal.prices_by_times.map((item) => {
                                // Check if it's a standard duration (multiple of interval)
                                const isStandard = item.duration > 0 && item.duration % interval === 0 && item.duration <= 180
                                return {
                                    id: item.id,
                                    value: isStandard ? item.duration : -1,
                                    price: item.price,
                                    personilize: isStandard ? null : item.duration,
                                    name: item.price_duration_description || newVal.name || '',
                                    prices_degressif: item.lot_prices_duration
                                        ? item.lot_prices_duration.map((lot) => ({
                                              persons: lot.nb_contributor,
                                              // Une durée de palier égale à celle de l'option est un
                                              // héritage (recopie) et ne vaut PAS surcharge : vide.
                                              // Une durée hors grille (ex. 195 min) doit se présenter
                                              // comme « Personnalisée » (-1) + sa valeur, sinon la
                                              // liste déroulante l'afficherait vide et un simple
                                              // enregistrement la perdrait.
                                              ...this.$store.getters['experience/getTierDurationFields'](lot),
                                              // 0 = « non renseigné » : vide ici, saisi à la Tarification.
                                              price: Number(lot.price) > 0 ? parseFloat(lot.price).toFixed(2) : '',
                                              editing: false,
                                          }))
                                        : [],
                                }
                            })

                            console.log('🔄 Step4 - allBlocks:', allBlocks)

                            // Set to store (first element is main duration)
                            this.$store.dispatch('experience/setDynamicDurationBlocks', allBlocks)

                            // Déplier les options qui portent DÉJÀ des paliers : sinon la
                            // configuration existante reste invisible derrière un lien qui ne
                            // signale rien, et l'utilisateur la croit perdue.
                            // Même intention que TarifItem.vue (mounted → isDegressifOpen), mais ici
                            // les blocs arrivent de façon asynchrone : on ne peut pas le faire au
                            // montage. D'où la garde par id, qui rend le dépliage à usage unique.
                            this.autoOpenConfiguredTiers(newVal.id, allBlocks)

                            // Set personilize_duration if first block is custom
                            if (allBlocks[0] && allBlocks[0].value === -1) {
                                this.personilize_duration = allBlocks[0].personilize
                            }
                        }
                    })

                    // Try to get from user_choices as fallback (for existing data)
                    const reservationMode = this.getUserChoiceValue('reservation_mode')
                    if (reservationMode && !this.$store.getters['experience/reservationMode']) {
                        console.log('🔍 Step4 - Using fallback from user_choices:', reservationMode)
                        // Also update store for consistency
                        this.$store.dispatch('experience/setReservationMode', reservationMode)
                    }

                    this.initializeExperience(newVal)
                    this.initialFormState = this.getCurrentFormState()

                    // ✅ FIX: Restore selectedOptionSpecifityHoraire from user_choices
                    const hasHoraireSpecefiq = this.getUserChoiceValue('has_horaire_specefiq')
                    if (hasHoraireSpecefiq !== null) {
                        this.selectedOptionSpecifityHoraire =
                            hasHoraireSpecefiq == 1 || hasHoraireSpecefiq == '1' || hasHoraireSpecefiq == true ? 1 : 0
                        console.log(
                            '✅ Step4 - Restored selectedOptionSpecifityHoraire from user_choices:',
                            this.selectedOptionSpecifityHoraire
                        )
                    } else {
                        // Fallback: Detect if custom schedules exist (planning_space_spe or planningSpacePersonalisy)
                        const hasCustomSchedules =
                            (this.localPrestation.planning_space_spe && this.localPrestation.planning_space_spe.length > 0) ||
                            (this.localPrestation.planningSpacePersonalisy &&
                                this.localPrestation.planningSpacePersonalisy.length > 0)

                        if (hasCustomSchedules) {
                            this.selectedOptionSpecifityHoraire = 1
                            console.log('✅ Step4 - Detected custom schedules (fallback detection)')
                        }
                    }

                    // Always refresh days from latest SpacePlanning data (only when custom hours mode)
                    if (
                        this.selectedOptionSpecifityHoraire === 1 &&
                        this.localPrestation.planningSpacePersonalisy &&
                        this.localPrestation.planningSpacePersonalisy.length > 0
                    ) {
                        this.days = this.mapApiResponseToDays(this.localPrestation.planningSpacePersonalisy)
                    }

                    if (this.localPrestation.planning_space_spe && this.localPrestation.planning_space_spe.length) {
                        this.horaires_specifiques = this.localPrestation.planning_space_spe.map((item) => {
                            const spec_horaire = {
                                dateStart: item.date,
                                dateEnd: item.date,
                                timeStart: item.start,
                                timeEnd: item.end,
                                lunchStart: item.lunch_start || null,
                                lunchEnd: item.lunch_end || null,
                                isPeack: !!(item.lunch_start && item.lunch_end),
                                label: this.formatDateFr(item.date) + ' ' + this.formatDateFr(item.date),
                                hours: item.start.split(':')[0] + 'h – ' + item.end.split(':')[0] + 'h',
                                label_days: this.getDaysBetween(item.date, item.date, 'fr'),
                                selectedDays: this.getDaysBetween(item.date, item.date, 'en').split(', '),
                            }
                            return spec_horaire
                        })
                    }
                    if (this.localPrestation.prestation_planning && this.localPrestation.prestation_planning.length) {
                        // Guard against rows without planning_prices so the immediate watch can't crash on
                        // item.planning_prices[0].start_time (PLPRB-1084 review).
                        this.events = this.localPrestation.prestation_planning
                            .filter((item) => item.planning_prices && item.planning_prices.length)
                            .map((item) => {
                                const pp = item.planning_prices[0]
                                const endDate = item.end_date && item.end_date !== SENTINEL_END_DATE ? item.end_date : null
                                const spec_horaire = {
                                    tmp_id: 'pp-' + item.id,
                                    dateStart: item.start_date,
                                    dateEnd: endDate,
                                    timeStart: pp.start_time,
                                    timeEnd: pp.end_time,
                                    lunchStart: pp.lunch_start || null,
                                    lunchEnd: pp.lunch_end || null,
                                    isPeack: !!(pp.lunch_start && pp.lunch_end),
                                    label: endDate
                                        ? this.formatDateFr(item.start_date) + ' ' + this.formatDateFr(endDate)
                                        : this.formatDateFr(item.start_date),
                                    hours: pp.start_time.split(':')[0] + 'h – ' + pp.end_time.split(':')[0] + 'h',
                                    label_days: this.getDaysBetween(item.start_date, endDate, 'fr'),
                                    selectedDays: this.getDaysBetween(item.start_date, endDate, 'en').split(', '),
                                }
                                return spec_horaire
                            })
                        // For multi-slot modes (multiple_time_slots) the day/hour tarifs are owned by the
                        // Step5 calendar/storePlanning flow — do NOT mirror them into horaires_specifiques.
                        // Sending this stale, price-less payload made the backend overwrite the real per-slot
                        // prices on a schedule save (PLPRB-1084). horaires_specifiques is event-mode only.
                    }
                }

                // Set initial data string after all initial processing is complete
                this.$nextTick(() => {
                    this.initialDataString = this.getFormDataString()
                    this.initialCustomScheduleString = this.getCustomScheduleString()
                    this.captureInitialCustomScheduleState()
                    // Fetch shared spaces status for the warning banner
                    if (newVal?.id) {
                        this.checkSharedSpaces()
                    }
                })
            },
            immediate: true,
            deep: true,
        },
        spaces_id: {
            async handler(newVal) {
                const count = newVal ? newVal.length : 0

                // Custom hours mode: use planningSpacePersonalisy only if custom hours were actually saved
                if (this.selectedOptionSpecifityHoraire === 1 && this.localPrestation) {
                    const savedChoice = this.getUserChoiceValue('has_horaire_specefiq')
                    if (
                        (savedChoice == 1 || savedChoice == '1') &&
                        this.localPrestation.planningSpacePersonalisy &&
                        this.localPrestation.planningSpacePersonalisy.length
                    ) {
                        this.days = this.mapApiResponseToDays(this.localPrestation.planningSpacePersonalisy)
                        return
                    }
                    // No custom hours saved yet — start with blank defaults
                    this.days = this.initializeEmptyDays()
                    return
                }

                if (count > 1) {
                    this.days = await this.fetchPlanningData()
                    this.$nextTick(() => {
                        this.initialDataString = this.getFormDataString()
                        this.initialCustomScheduleString = this.getCustomScheduleString()
                        this.captureInitialCustomScheduleState()
                    })
                    return
                }

                if (count === 1 && this.localPrestation) {
                    if (this.localPrestation.planningSpacePersonalisy && this.localPrestation.planningSpacePersonalisy.length) {
                        this.days = this.mapApiResponseToDays(this.localPrestation.planningSpacePersonalisy)
                        return
                    }
                }

                // Fallback: fetch establishment default schedule (new experience or no custom data)
                this.days = await this.fetchPlanningData()
                this.$nextTick(() => {
                    this.initialDataString = this.getFormDataString()
                    this.initialCustomScheduleString = this.getCustomScheduleString()
                    this.captureInitialCustomScheduleState()
                })
            },
            immediate: true,
            deep: true,
        },
        selectedOptionSpecifityHoraire(newVal) {
            if (newVal == 1 && this.localPrestation) {
                // Show actual space hours from SpacePlanning
                if (this.localPrestation.planningSpacePersonalisy && this.localPrestation.planningSpacePersonalisy.length) {
                    this.days = this.mapApiResponseToDays(this.localPrestation.planningSpacePersonalisy)
                } else {
                    this.days = this.initializeEmptyDays()
                }
            }
        },
        filteredOptionsDurations: {
            handler(newVal) {
                EventBus.$emit('update-durations', newVal)
            },
            deep: true,
            immediate: true, // emit immediately on component mount
        },
        selected_duration_experience: {
            handler(newVal, oldVal) {
                // Clear duration error when user selects a value
                if (newVal !== null && newVal !== undefined && this.errors.duration) {
                    this.$delete(this.errors, 'duration')
                }
                // Only reset personilize_duration when user actively changes the dropdown
                // (not during initial load or returning to this step)
                if (oldVal === undefined || oldVal === null) return
                if (newVal !== -1 && newVal !== null) {
                    // User picked a standard duration — clear custom duration field
                    this.personilize_duration = this.maxDuration + this.minDuration
                }
            },
        },
        // Watcher pour réinitialiser selected_duration_experience quand selected_interval_reservation change
        selected_interval_reservation: {
            handler(newVal, oldVal) {
                // Ne pas reset si c'est l'initialisation ou si la valeur est la même
                if (oldVal === undefined || oldVal === null || newVal === oldVal) return
                this.selected_duration_experience = null
                // Aussi réinitialiser les blocs dynamiques
                this.$store.dispatch('experience/clearDynamicDurationBlocks')
            },
        },
    },
    async created() {
        console.log('ddd', 'ddd')
        this.options_interval_reservation = Array.from({ length: (210 - 10) / 5 + 1 }, (_, i) => ({
            label: formatDuration(10 + i * 5, this.$i18n),
            value: 10 + i * 5,
        }))
    },
}
</script>

<style scoped>
.selected-option {
    background-color: #e3f2fd;
    /* light blue highlight */
}

.v-list-item {
    cursor: pointer;
}

.border_duration_experience {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 12px;
    border: 1px solid #545595;
    min-height: 54px;
}

.border_duration_experience label {
    font-family: 'Poppins Regular', sans-serif;
}

/* Partie gauche */
.form-section {
    flex: 1;
}

/* --- BOUTONS AJOUT/SUPPRESSION --- */
.transparent-btn {
    border-radius: 12px !important;
    width: 100% !important;
    height: 100% !important;
    box-shadow: none !important;
    position: absolute;
    left: 0;
    top: 0;
    border: none;
}

.transparent-btn:hover {
    background: #d9d9d91a !important;
}

/* --- TOGGLE --- */
.toggle_section {
    margin-top: 30px;
    padding: 20px;
    border-radius: 16px;
    border: 1px dashed rgba(124, 124, 255, 0.4);
    background: rgba(255, 255, 255, 0.03);
    color: #ffffff;
}

.v-switch .v-selection-control__input {
    color: #6c69ff !important;
}

.schedule-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

/* --- TITRE CONFIGURER LES HORAIRES --- */
.v-switch label {
    font-family: 'Poppins SemiBold', sans-serif;
    font-size: clamp(12px, 0.729545vw, 16px);
    color: #ffffff;
}

.gestion_creneau {
    background-color: #1a1f370d;
    padding: 10px 12px;
}

/* ── Duration options block ─────────────────────────────── */
.duration-options-section {
    border: 1px solid #6f74b6;
    border-radius: 12px;
    overflow: visible;
    /* background: #f7f8fd; */
}

.duration-options-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 16px;
    border-bottom: 1px solid #c8cbeb;
    /* background: #f2f3fb; */
}

.duration-options-title {
    margin: 0;
    font-family: 'Poppins Medium', sans-serif;
    font-size: 13px;
    color: #1b2452;
    flex: 1;
}

.duration-options-badge {
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: 'Poppins Medium', sans-serif;
    font-size: 11px;
    color: #6b70b4;
    background: #e7e9f8;
    border: 1px solid #b4b8de;
}

.duration-options-body {
    min-height: 0;
    /* background: #f7f8fd; */
    overflow: visible;
}

.duration-options-empty {
    padding: 18px 20px;
    margin: 0;
    font-family: 'Poppins Regular', sans-serif;
    font-size: 12px;
    color: #1b2452;
    opacity: 0.45;
    text-align: center;
}

.duration-option-row {
    padding: 10px 16px 16px 16px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
    min-height: 72px;
    position: relative;
    z-index: 1;
}

.duration-option-row:focus-within {
    z-index: 30;
}

.duration-option-item + .duration-option-item .duration-option-row {
    border-top: 1px solid #d7daf1;
}

.duration-option-row-head {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: flex-end;
    padding-bottom: 2px;
}

.duration-option-name-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #1b2452;
    overflow: hidden;
}

.duration-option-name {
    font-family: 'Poppins Medium', sans-serif;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.duration-option-edit {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #545595;
    opacity: 0;
    cursor: pointer;
    transition:
        opacity 0.15s ease,
        background-color 0.15s ease;
}

.duration-option-row:hover .duration-option-edit {
    opacity: 1;
}

.duration-option-edit:hover {
    background: rgba(84, 85, 149, 0.12);
}

.duration-option-controls {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    flex-shrink: 0;
}

.duration-option-select-wrap {
    display: flex;
    align-items: flex-end;
    gap: 8px;
}

.duration-option-remove-wrap {
    width: 34px;
    min-width: 34px;
    height: 34px;
    position: relative;
    align-self: flex-end;
    margin-bottom: 0;
}

.duration-option-remove-spacer {
    width: 34px;
    min-width: 34px;
    height: 34px;
}

.duration-option-add-wrapper {
    margin-top: 10px;
    border: 1px dashed #aeb3da;
    border-radius: 12px;
    overflow: hidden;
    transition: border-color 0.15s ease;
}

.duration-option-add-wrapper:hover {
    border-color: #8f94c9;
}

/* Paliers « durée par nombre de personnes » sous chaque option de durée. */
.tier-toggle-link {
    border: none;
    background: transparent;
    /* Le retrait horizontal de la carte vit sur .duration-option-row, dont ce lien est le FRÈRE
       et non l'enfant : il doit donc reprendre les mêmes 16px à son compte. */
    padding: 2px 16px 10px 16px;
    color: #575c9f;
    font-family: 'Poppins Medium', sans-serif;
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
}

.tier-toggle-link:hover {
    color: #4c5394;
}

.tier-panel {
    border-top: 1px solid rgba(84, 85, 149, 0.12);
    /* Le padding est INTÉRIEUR à la bordure : le séparateur reste pleine largeur alors que le
       contenu s'aligne sur « Option 1 ». */
    padding: 12px 16px 0 16px;
    margin-bottom: 8px;
}

.tier-hint {
    font-family: 'Poppins Regular', sans-serif;
    font-size: 11px;
    opacity: 0.65;
    /* Les champs ont un libellé flottant posé sur leur bordure haute : 10px le faisait frôler. */
    margin-bottom: 14px;
}

/* Message d'erreur sous le champ Durée d'un palier. Même ton que les autres erreurs de l'étape. */
.tier-field-error {
    margin-top: 4px;
    font-family: 'Poppins Regular', sans-serif;
    font-size: 11px;
    color: #ed4b9e;
}

.tier-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

/* Pas de creux avant « Ajouter un palier », qui porte déjà sa propre hauteur. */
.tier-field-error {
    margin-top: 4px;
    font-family: 'Poppins Regular', sans-serif;
    font-size: 11px;
    color: #ed4b9e;
}

.tier-row:last-of-type {
    margin-bottom: 4px;
}

.tier-label {
    font-family: 'Poppins Medium', sans-serif;
    font-size: 12px;
    min-width: 62px;
}

.tier-field {
    flex: 1 1 120px;
    min-width: 110px;
}

.duration-option-add-btn {
    width: 100%;
    height: 44px;
    border: none;
    background: transparent;
    color: #575c9f;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: 'Poppins Medium', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition:
        color 0.15s ease,
        background-color 0.15s ease;
}

.duration-option-add-btn:hover {
    color: #4c5394;
    background-color: rgba(84, 85, 149, 0.04);
}

@media (max-width: 900px) {
    .duration-option-row {
        flex-wrap: wrap;
    }

    .duration-option-controls {
        width: 100%;
    }

    .duration-option-select-wrap {
        flex: 1;
    }
}

.dark .gestion_creneau {
    background-color: rgba(255, 255, 255, 0.05);
}

/* Dark mode overrides for duration options */
.dark .duration-options-header {
    background: rgba(255, 255, 255, 0.04);
    border-bottom-color: rgba(255, 255, 255, 0.12);
}

.dark .duration-options-title {
    color: #ffffff;
}

.dark .duration-options-badge {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.25);
}

.dark .duration-options-empty {
    color: rgba(255, 255, 255, 0.4);
}

.dark .duration-option-row:hover {
    background: rgba(255, 255, 255, 0.04);
}

.dark .duration-option-item + .duration-option-item .duration-option-row {
    border-top-color: rgba(255, 255, 255, 0.1);
}

.dark .duration-option-name-wrap {
    color: rgba(255, 255, 255, 0.9);
}

.dark .duration-option-edit {
    color: rgba(255, 255, 255, 0.7);
}

.dark .duration-option-edit:hover {
    background: rgba(255, 255, 255, 0.12);
}

.dark .duration-option-remove-wrap {
    background: transparent;
}

.dark .duration-option-remove-btn {
    border-color: rgba(255, 255, 255, 0.25);
    background: transparent;
    color: rgba(255, 255, 255, 0.8) !important;
}

.dark .duration-option-remove-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.42);
}

.dark .duration-option-add-wrapper {
    border-color: rgba(132, 140, 230, 0.4);
}

.dark .duration-option-add-btn {
    color: rgba(255, 255, 255, 0.65);
}

/* Les classes tier-* n'avaient aucune variante sombre : le lien restait en indigo #575c9f sur fond
   sombre (contraste insuffisant) et le séparateur du panneau était quasi invisible. */
.dark .tier-toggle-link {
    color: rgba(255, 255, 255, 0.75);
}

.dark .tier-toggle-link:hover {
    color: rgba(255, 255, 255, 0.95);
}

.dark .tier-panel {
    border-top-color: rgba(255, 255, 255, 0.1);
}

.dark .duration-option-add-btn:hover {
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0.06);
}

.duration-option-remove-btn {
    width: 34px;
    min-width: 34px;
    height: 34px;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #a8add7;
    border-radius: 999px;
    background: transparent;
    color: #545595 !important;
    box-shadow: none !important;
    cursor: pointer;
    transition:
        background-color 0.15s ease,
        border-color 0.15s ease;
}

.duration-option-remove-btn:hover {
    background: rgba(84, 85, 149, 0.08);
    border-color: #7d82bf;
}

.duration-option-remove-btn:focus {
    outline: none;
}

.duration-option-remove-btn:focus-visible {
    outline: 2px solid rgba(84, 85, 149, 0.35);
    outline-offset: 1px;
}

.dark .duration-option-add-btn:hover {
    background-color: rgba(255, 255, 255, 0.08);
}
</style>
